"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["handleStepButtonOnClick", "iconStep", "iconSuccess", "infos", "page", "pages", "itemProps", "itemIconProps", "showStep"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var object_hash_1 = __importDefault(require("object-hash"));

var react_2 = __importStar(require("react"));

var index_1 = require("../../index");

var ProgressBarSC = styled_1.default.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  position: relative;\n  padding-bottom: 3rem;\n"])));
var ProgressBarItemSC = styled_1.default.li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: table-cell;\n  text-align: center;\n  vertical-align: top;\n  overflow: visible;\n  position: relative;\n  font-weight: bold;\n\n  &:not(:last-child):before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 60%;\n    background-color: ", ";\n    height: 4px;\n    width: 80%;\n    border-radius: 4px;\n  }\n\n  ", ";\n\n  ", ";\n\n  > button {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    left: 50%;\n    top: -13px;\n    color: ", ";\n    margin-left: -15px;\n    outline: none;\n  }\n"])), function (props) {
  return props.inProgress || props.isCompleted ? '#112255' : '#e7e9ee';
}, function (props) {
  return props.isCompleted && (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      &:before {\n        background-color: #112255;\n      }\n    "])));
}, function (props) {
  return props.inProgress && (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      &:before {\n        background: #112255;\n        background: linear-gradient(\n          to right,\n          #112255 0%,\n          #112255 50%,\n          #e7e9ee 50%\n        );\n      }\n    "])));
}, function (props) {
  return props.inProgress || props.isCompleted ? '#112255' : '#e7e9ee';
});
var ProgressBarItemIconSC = styled_1.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  border: 2px solid ", ";\n  border-radius: 30px;\n  height: 30px;\n  width: 30px;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0.375rem;\n  color: ", ";\n  font-weight: 600;\n\n  ", ";\n"])), function (props) {
  return props.inProgress ? '#112255' : '#e7e9ee';
}, function (props) {
  return props.inProgress || props.isCompleted ? '#112255' : '#e7e9ee';
}, function (props) {
  return props.isCompleted && (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      border: none;\n      background: #112255;\n      color: #fff;\n    "])));
});
var ProgressBarItemStepSC = styled_1.default.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: #e7e9ee;\n"])));
var ProgressBarItemTitleSC = styled_1.default.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  position: relative;\n  left: calc(-50% + 15px);\n  color: inherit;\n"])));

var ProgressBar = function ProgressBar(_ref) {
  var handleStepButtonOnClick = _ref.handleStepButtonOnClick,
      iconStep = _ref.iconStep,
      iconSuccess = _ref.iconSuccess,
      infos = _ref.infos,
      page = _ref.page,
      pages = _ref.pages,
      itemProps = _ref.itemProps,
      itemIconProps = _ref.itemIconProps,
      showStep = _ref.showStep,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_2.useContext)(index_1.FormidableContext),
      sc = _ref2.sc;

  var IconStep = iconStep;
  var IconSuccess = iconSuccess; // TODO revoir ce composant

  return react_2.default.createElement(ProgressBarSC, _objectSpread({
    as: sc && sc.progressBar
  }, props), infos.map(function (info, i) {
    return react_2.default.createElement(ProgressBarItemSC, _objectSpread(_objectSpread(_objectSpread({
      key: "".concat((0, object_hash_1.default)(_objectSpread(_objectSpread({}, infos[i]), {}, {
        i: i
      }))),
      as: sc && sc.progressBarItem
    }, itemProps), info), {}, {
      isCompleted: i < page
    }), react_2.default.createElement("button", {
      "data-page": i,
      onClick: handleStepButtonOnClick,
      type: "button"
    }, react_2.default.createElement(ProgressBarItemIconSC, _objectSpread(_objectSpread(_objectSpread({
      "aria-label": "step ".concat(i + 1),
      as: sc && sc.progressBarItemIcon
    }, itemIconProps), info), {}, {
      isCompleted: i < page
    }), i < page && IconSuccess && react_2.default.createElement(IconSuccess, {
      size: 16
    }), i >= page && showStep && IconStep && react_2.default.createElement(IconStep, {
      size: 12
    }), i >= page && (!showStep || !IconStep) && react_2.default.createElement("span", null, i + 1)), showStep && react_2.default.createElement(ProgressBarItemStepSC, {
      as: sc && sc.progressBarItemStep
    }, "step ".concat(i + 1)), react_2.default.createElement(ProgressBarItemTitleSC, {
      as: sc && sc.progressBarItemTitle
    }, pages[i].title)));
  }));
};

exports.default = ProgressBar;